import { DownloadOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Progress, Spin, Table, Tooltip } from 'antd';
import React from 'react';
import ExportTypes  from './type'
import { Utils } from '@/tools/utils';
import '../returnVisit/index.less';

class ExportList extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            list: [],
        };
    }

    isNull = (str)=>{
        return !str || str === 'undefined' || str === 'null' || str === 'NULL' || str === 'NaN';
    }

    getColumns = (item) => {
        let columnsData = [];// : { render: () => JSX.Element }[]
        Object.keys(item.detail).forEach(key => {
            let exportTypeStr = item.exportType;
            if (item.exportType.indexOf('CONTINUE_RATE_')!==-1) { exportTypeStr = 'CONTINUE_RATE_LIST'; }
            const selectExportType = ExportTypes[exportTypeStr] || ExportTypes.POLICY_ACK_INFO_MERCHANT;
            const keyCN = selectExportType[key];
            if (item.detail[key] && keyCN && !Array.prototype.isPrototypeOf(item.detail[key])) {
                const contentV =  keyCN.type ? keyCN.type[item.detail[key]] : String(item.detail[key]);
                if (!this.isNull(contentV)){
                    columnsData.push({
                        render: () => {
                            return <div className={ 'columnsItem' } key={`${item.id}${keyCN.title}`} >
                                { keyCN.title } : { contentV }
                            </div>;
                        }
                    });
                }
            } else if (item.detail[key] && keyCN && Array.prototype.isPrototypeOf(item.detail[key]) && item.detail[key].length !== 0) {
                columnsData.push({
                    render: () => {
                        return <Tooltip  key={`${item.id}${keyCN.title}`} placement={ 'topLeft' } title={ item.detail[key].map((det) => {
                            return det + ' & ';
                        }) }>
                            <div className={ 'columnsItem' }>
                                { keyCN.title } : { item.detail[key].map((det) => {
                                return det + ' & ';
                            }) }
                            </div>
                        </Tooltip>;
                    }
                });
            }
        });
        return columnsData;
    }

    columns_visit = [
        {
            title: '', align: 'center', width: 230,key: '1',
            render: (item) => {
                return <div key={item.key} style={{minHeight:'54px',textAlign:'start'}}>
                    { this.getColumns(item).map(val => {
                        return val.render();
                    }) }
                </div>;
            }
        },
    ]
    trTitle_visit = [
        { title: '生成报表时间', dataIndex: 'completionTime', },
        { title: '报表类型', dataIndex: 'exportTypeDesc', },
        { title: '', dataIndex: 'eventStatus',
            render: (item) => {
                return (
                    <div>
                        {item.eventStatus === 2 &&
                        <Button
                            size={ 'small' }
                            type='primary'
                            onClick={ () => {
                                if (item.exportType === 'POLICY_ACK_INFO_MERCHANT') {
                                    Utils.customTrack('MerchantPolicyVisitStatementClick', {
                                        element_content: '下载报表'
                                    });
                                }
                                window.open(item.fileUrlPath, '_blank');
                            } }
                            icon={<DownloadOutlined />}
                        >下载报表</Button> }
                        {(item.eventStatus === 0 || item.eventStatus === 1)  &&
                        <Progress
                            style={{width:'200px'}}
                            strokeColor={{
                                '0%': '#108ee9',
                                '100%': '#87d068',
                            }}
                            percent={ 70 }// item.eventStatus === 0 ? Number((Math.random() * 50).toFixed(1)) : 50 + Number((Math.random() * 50).toFixed(1))
                        />
                        }
                        {item.eventStatus === 99 && <Tooltip placement="topLeft" title={item.failureMsg}>
                            <div className={'failMsgTip'}>
                                { item.failureMsg }
                            </div>
                        </Tooltip>}
                    </div>
                );
            }
        },
    ]
    getTitle = (item) => {
        if( item.eventStatus === 2){
            return '';
        }
        if (item.eventStatus === 0 || item.eventStatus === 1){
            return '报表生成中';
        }
        if (item.eventStatus === 99){
            return '报表生成失败';
        }
    }
    render() {

        return <Spin size="large" spinning={ this.props.loading }>
            { this.state.list.map((item, index) => {
                item.key = item.id;
                return <div key={ `${item.id}${index}` } className='contentBox' >
                    <Table
                        rowKey={r=>`${r.id}${r.id}`}
                        showSorterTooltip
                        pagination={ false }
                        className='TableBox'
                        columns={ this.columns_visit }
                        dataSource={ [ item ] }
                        bordered
                        showHeader={ false }
                        title={ () => {
                            return <Form
                                className='FormBox'
                                layout='inline'
                                size='small'>
                                { this.trTitle_visit.map((val, ind) => {
                                    return <Form.Item key={ ind } label={ val.title ? val.title : this.getTitle(item) }>
                                        { val.render ? val.render(item) : item[val.dataIndex] }
                                    </Form.Item>;
                                }) }
                            </Form>;
                        } }
                    />
                </div>;
            }) }
        </Spin>;
    }
}

export default ExportList;
